export default __webpack_public_path__ + "static/media/239.f1fdbc63.jpg";